

export function prettifyTimestamp(timestamp, use12Hour) {
    const now = new Date();
    const messageDateTime = new Date(timestamp);

    const day = messageDateTime.getDay();
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    const startOfToday = new Date(now.setHours(0,0,0,0));
    const startOfDate = new Date(new Date(timestamp).setHours(0,0,0,0));

    const dayDifference = (startOfToday - startOfDate) / (1000 * 60 * 60 * 24);

    const timeString = messageDateTime.toLocaleString(undefined,
        { hour: 'numeric', minute: 'numeric', hour12: use12Hour});

    if (dayDifference < 1) {
        return timeString;
    } else if (dayDifference < 7) {
        return `${days[day]} ${timeString}`;
    } else if (startOfDate.getFullYear() === startOfToday.getFullYear()) {
        const dateString = messageDateTime.toLocaleString(undefined,
            { month: 'short', day: 'numeric' });
        return `${dateString} ${timeString}`;
    } else {
        const dateString = messageDateTime.toLocaleString(undefined,
            { year: 'numeric', month: 'short', day: 'numeric' });
        return `${dateString} ${timeString}`;
    }
}

export function processDateString(inputString, use12Hour) {
    const matches = inputString.match(/\{([^}]+)\}/g);
    if (matches) {
        for (const match of matches) {
            const processedDatetime = prettifyTimestamp(match.slice(1, -1), use12Hour);
            inputString = inputString.replace(match, processedDatetime);
        }
    }
    return inputString;
}

export function chatHttpCall(baseUrl, chatToken, endpoint, method, params= {}){
    method = method.toUpperCase();

    let url = new URL(baseUrl+endpoint);
    let opts = {
        method: method,
        mode: 'cors',
        headers: {
            'Accept': 'application/json',
            'Authorization': 'Bearer '+chatToken
        },
    };

    if (method==="GET" || method==="DELETE"){
        Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
    } else if (method==="PUT" || method==="POST"){
        opts.headers['Content-Type'] = 'application/json';
        opts.body = JSON.stringify(params);
    }

    return fetch(url, opts);
}
